import SchoolV5Schema from 'resources/augmented/School/schemas/school_v5.schema.json';

import type {SchoolData} from '../onboarding.types';
import type {CreatedHomeschool, HomeschoolAction, SchoolType} from './schoolAssociation.types';

export const USA = 'United States of America';

export const COUNTRY_OPTIONS = (
  SchoolV5Schema.properties.data.properties.attributes.properties.country.enum as string[]
).map((c) => ({label: c, value: c}));

export function buildSchoolData(
  selectedType: SchoolType,
  homeschoolAction: HomeschoolAction,
  selectedSchool: any,
  createdHomeschool: CreatedHomeschool | null
): SchoolData {
  if (selectedType === 'school' && selectedSchool) {
    return {schoolId: selectedSchool.getId?.()};
  }

  if (selectedType === 'homeschool') {
    if (homeschoolAction === 'created' && createdHomeschool) {
      return {
        homeschool: {
          action: 'create',
          name: createdHomeschool.name,
          country: createdHomeschool.country,
          city: createdHomeschool.city,
          state: createdHomeschool.state
        }
      };
    }
    if (homeschoolAction === 'join-existing' && selectedSchool) {
      return {homeschool: {action: 'join', schoolId: selectedSchool.getId?.()}};
    }
  }

  return {};
}

export function isContinueDisabled(
  selectedType: SchoolType,
  homeschoolAction: HomeschoolAction,
  selectedSchool: any,
  createdHomeschool: CreatedHomeschool | null,
  isSubmitting?: boolean
): boolean {
  if (isSubmitting) return true;
  // Single source of truth: disabled iff `buildSchoolData` can't produce a payload.
  const data = buildSchoolData(selectedType, homeschoolAction, selectedSchool, createdHomeschool);
  return Object.keys(data).length === 0;
}
